import { makeStyles } from "@mui/styles";
import { Theme } from "@p81-common/ui";

export const createClasses = makeStyles<Theme>((theme) => ({
  title: {
    margin: theme.spacing(2, 0, 1, 0),
    color: theme.palette.primary[500],
  },
}));
